// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import DiagnosePage from "../pages/Diagnose/Diagnose";
const __wvcRoutePaths = ["/DiagnosePage", "/diagnose"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["3d-scanning-reverse-engineering", "cad-konstruktion", "cadkonstruktionpage", "contactpage", "controlunitspage", "dataprotectionpage", "datenschutz", "diagnose", "diagnosepage", "fertigung-bearbeitung", "fertigungbearbeitungpage", "homepage", "impressum", "imprintpage", "keyservicepage", "kontakt", "optimierungpage", "post", "privacypage", "reifenservice", "reifenservicepage", "scanning3dpage", "schlussel-service", "software-leistungsoptimierung", "startseite", "steuergerate"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<DiagnosePage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<DiagnosePage />} />
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
